import { render, staticRenderFns } from "./RegisterUserView.vue?vue&type=template&id=2ca36e01"
import script from "./RegisterUserView.vue?vue&type=script&lang=js"
export * from "./RegisterUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports